import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // http://wechat.suzhougs.com/manage/dist/#/
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login')
  },
  {
    path: '/loginToFlow', // PC端转让公司登录
    name: 'LoginToFlow',
    component: () => import('@/views/LoginToFlow')
  },
  {
    path: '/loginFlow', // 微信转让公司登录
    name: 'LoginFlow',
    component: () => import('@/views/LoginFlow')
  },
  {
    path: '/loginBindFlow', // 微信转让公司注册
    name: 'LoginBindFlow',
    component: () => import('@/views/LoginBindFlow')
  },
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Welcome')
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: () => import('@/views/Welcome')
  },
  {
    path: '/blank/:id?&:targetName?&:code?',
    name: 'Blank',
    component: () => import('@/views/Blank')
  },
  {
    path: '/blankTest/:id?&:targetName?&:code?',
    name: 'BlankTest',
    component: () => import('@/views/BlankTest')
  },
  {
    path: '/scan/:id?&:code?',
    name: 'Scan',
    component: () => import('@/views/Scan')
  },
  {
    path: '/sign/:id?&:code?',
    name: 'Sign',
    component: () => import('@/views/Sign')
  },
  {
    path: '/third/:id?&:code?',
    name: 'Third',
    component: () => import('@/views/Third')
  },
  // http://wechat.suzhougs.com/manage/dist/?id=1&targetName=Invoice&wechatLogin=true&state=123
  {
    path: '/invoice', // 客户开票服务
    name: 'Invoice',
    component: () => import('@/views/Invoice')
  },
  {
    path: '/caseShare/:id?', // 分享案件填写
    name: 'CaseShare',
    component: () => import('@/views/CaseShare/CaseShare')
  },
  {
    path: '/main',
    name: 'MainPage',
    component: () => import('@/views/MainPage'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/Home')
      },
      {
        path: 'role',
        name: 'Role',
        component: () => import('@/views/Role')
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/User')
      },
      {
        path: 'company',
        name: 'Company',
        component: () => import('@/views/Company/Company')
      },
      {
        path: 'companyDetail/:id?&:webState?',
        name: 'CompanyDetail',
        component: () => import('@/views/Company/CompanyDetail')
      },
      // http://wechat.suzhougs.com/manage/dist/?id=1&targetName=Customer&wechatLogin=true&state=123
      {
        path: 'customer',
        name: 'Customer',
        component: () => import('@/views/Customer/Customer')
      },
      {
        path: 'customerDetail/:id?&:webState?',
        name: 'CustomerDetail',
        component: () => import('@/views/Customer/components/CustomerDetail')
      },
      // http://wechat.suzhougs.com/manage/dist/?id=1&targetName=Case&wechatLogin=true&state=123
      {
        path: 'case',
        name: 'Case',
        component: () => import('@/views/Case/Case')
      },
      {
        path: 'caseDetail/:id?&:webState?',
        name: 'CaseDetail',
        component: () => import('@/views/Case/components/CaseDetail')
      },
      {
        path: 'statistic',
        name: 'Statistic',
        component: () => import('@/views/Statistic')
      },
      {
        path: 'version',
        name: 'Version',
        component: () => import('@/views/Version')
      },
      {
        path: 'userQrcode',
        name: 'UserQrcode',
        component: () => import('@/views/UserQrcode')
      },
      {
        path: 'invoiceAudit',
        name: 'InvoiceAudit',
        component: () => import('@/views/InvoiceAudit.vue')
      },
      {
        path: 'refresh',
        name: 'Refresh',
        component: () => import('@/views/Refresh.vue')
      },
      {
        path: 'flowAudit',
        name: 'FlowAudit',
        component: () => import('@/views/Flow/FlowAudit.vue')
      },
      {
        path: 'flowAuditDetail/:id?&:webState?',
        name: 'FlowAuditDetail',
        component: () => import('@/views/Flow/FlowAuditDetail')
      }
    ]
  },
  {
    path: '/flow',
    name: 'FlowPage',
    component: () => import('@/views/FlowPage'),
    children: [
      {
        path: 'flowList',
        name: 'Flow',
        component: () => import('@/views/Flow/Flow.vue')
      },
      {
        path: 'flowDetail/:id?&:webState?',
        name: 'FlowDetail',
        component: () => import('@/views/Flow/FlowDetail')
      }
    ]
  },
  {
    path: '/flowPublic',
    name: 'FlowPublicPage',
    component: () => import('@/views/FlowPublicPage'),
    children: [
      {
        path: 'flowList', // 公开的查询列表
        name: 'FlowPublic',
        component: () => import('@/views/Flow/FlowPublic.vue')
      },
      {
        path: 'flowDetail/:id?&:webState?', // 公开的查询详情
        name: 'FlowPublicDetail',
        component: () => import('@/views/Flow/FlowPublicDetail.vue')
      },
      {
        path: 'flowListBySelf', // 当前用户发布的列表
        name: 'FlowPublicBySelf',
        component: () => import('@/views/Flow/FlowPublicBySelf.vue')
      },
      {
        path: 'flowDetailBySelf/:id?&:webState?', // 当前用户发布的列表
        name: 'FlowPublicBySelfDetail',
        component: () => import('@/views/Flow/FlowPublicBySelfDetail.vue')
      }
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
